module.exports = __webpack_public_path__ + "static/media/back-to-bottom.43a293d8.svg";